<template>
    <div class="scrollbutton d-flex ">
        <svg class="circle" width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26" cy="26" r="25.5" transform="rotate(90 26 26)" stroke="#AA615F"/>
            <path d="M36.5625 23.5625L26 34.125M26 34.125L15.4375 23.5625M26 34.125L26 0.8125" stroke="#AA615F"/>
        </svg>
        <svg class="line" width="2" height="111" viewBox="0 0 2 111" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 111L1 0.5" stroke="#AA615F"/>
        </svg>
    </div>
</template>
<script>
    export default {
        name: "Scrollbutton"
    }
</script>
<style scoped lang="scss">
    .scrollbutton {
        position: fixed;
        display: flex;
        flex-direction: column;
        bottom: 0;
        transition: transform 0.5s linear;
        @include mobile {
            transform: translateY(100px);
        }
        &.active {
            transform: translateY(105px);
            @include mobile {
                transform: translateY(100%);
            }
        }
        &:hover, &:focus {
            .circle {
                fill: $zzcolor;

                path {
                    stroke: #fff;
                }
            }
        }
        left: calc(50% - 26px);
        z-index: 100000001;
        cursor: pointer;
        .line {
            margin-left: calc(50% - 1px);
        }
    }
</style>